//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
name: 'CZhead2';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'identities']),
  },
};
